<div class="collab-list-item-container user-img-show-indicator" (click)="onClickEvent()">
    <div class="collab-list-item-user-image">
        <user-image
            imageSize="small"
            [hasImage]="user.hasImage"
            [imagePath]="user.image"
            [userInitials]="user.initial"
            [userRegistered]="user.isRegistered">
        </user-image>
    </div>
    <div class="collab-list-item-inner">
        <p class="collab-list-item-collab-name fx-ellipsis body">{{user.fullName}}</p>
        <p class="collab-list-item-collab-email fx-ellipsis grey caption">{{user.email}}</p>
    </div>
</div>